/**
 * Parsers for common scale serial protocols.
 * Each parser receives a raw string buffer from the serial port
 * and returns { peso, unidad, estable } or null if the frame is incomplete.
 */

// Zebra MP7000 / Symbol scale: sends weight as "wNNNNNN" or status frames.
// Weight is in grams or the configured unit. Stable indicator varies by firmware.
function parseZebra(buffer) {
  // Common format: S<status><weight>\r\n  or  wNNNNNN\r\n
  const match = buffer.match(/[Ss]\s*([SU])\s*([\d.]+)\s*(kg|lb|g|oz)?/);
  if (match) {
    return {
      peso: parseFloat(match[2]),
      unidad: match[3] || 'kg',
      estable: match[1] === 'S',
    };
  }
  // Simpler format: just a number followed by unit
  const simple = buffer.match(/([\d.]+)\s*(kg|lb|g|oz)/i);
  if (simple) {
    return {
      peso: parseFloat(simple[1]),
      unidad: simple[2].toLowerCase(),
      estable: true,
    };
  }
  return null;
}

// Mettler Toledo: typical format "SS,GS, NNNNN.NN UU\r\n"
// SS = status (ST=stable, US=unstable), GS = gross/net
function parseToledo(buffer) {
  const match = buffer.match(/(ST|US)\s*,\s*(?:GS|NS)\s*,\s*([-\d.]+)\s*(kg|lb|g|oz)?/i);
  if (match) {
    return {
      peso: parseFloat(match[2]),
      unidad: (match[3] || 'kg').toLowerCase(),
      estable: match[1].toUpperCase() === 'ST',
    };
  }
  return null;
}

// CAS scales: format varies, common pattern "ST,GS,+NNNNNN g\r\n"
function parseCAS(buffer) {
  const match = buffer.match(/(ST|US|OL)\s*,\s*(?:GS|NT)\s*,\s*[+-]?\s*([\d.]+)\s*(kg|lb|g|oz)?/i);
  if (match) {
    if (match[1] === 'OL') return { peso: 0, unidad: 'kg', estable: false };
    return {
      peso: parseFloat(match[2]),
      unidad: (match[3] || 'kg').toLowerCase(),
      estable: match[1].toUpperCase() === 'ST',
    };
  }
  return null;
}

// Generic: extracts the first decimal number from the buffer
function parseGenerico(buffer) {
  const match = buffer.match(/([\d]+\.?\d*)\s*(kg|lb|g|oz)?/i);
  if (match) {
    return {
      peso: parseFloat(match[1]),
      unidad: (match[2] || 'kg').toLowerCase(),
      estable: true,
    };
  }
  return null;
}

const PARSERS = {
  zebra: parseZebra,
  toledo: parseToledo,
  cas: parseCAS,
  generico: parseGenerico,
};

export function parsearPeso(protocolo, buffer) {
  const parser = PARSERS[protocolo] || PARSERS.generico;
  return parser(buffer);
}

export default PARSERS;
